module.exports = __webpack_public_path__ + "static/media/subabrata.c904b495.jpg";